import React from 'react';
import './Infographic.scss';
import ellipse from '../../assets/ellipse.png';
import allogeneic from '../../assets/allogeneic.png';
import autologous from '../../assets/autologous.png';
import infographicM from '../../assets/infographicM.png';
import carTLogo from '../../assets/carTLogo.png';

function Infographic() {
  return (
    <div className="infographic">
      <img src={carTLogo} alt="" className="infographic__logo" />
      <img src={ellipse} alt="" className="infographic__ellipse" />
      <div className="infographic__text">
        <h4 className="infographic__text__head">
          Allogeneic Product Candidates vs. Autologous CAR T Procedure
        </h4>
        <p className="infographic__text__subHead">
          The difference in delivery time is noticeable between the two methods of producing CAR T
          therapies. “Autologous” can take up to five weeks, if not longer, to reach the patient
          whereas "allogeneic" CAR T therapies (including AlloCAR T™ Products) can reach a patient
          in just a few days.
        </p>
      </div>

      <div className="infographic__chart infographic__chart-desktop">
        <div className="infographic__chart__type infographic__chart__type--allogenic">
          <h5 className="infographic__chart__type__title">Allogeneic Products (2 to 5 Days)</h5>
          <img
            src={allogeneic}
            alt="Patient Identification - Lymphodepletion - AlloCAR T Product Administration"
            className="infographic__chart__type__img"
          />
          <div />
        </div>
        <div className="infographic__chart__type infographic__chart__type--autologous">
          <h5 className="infographic__chart__type__title">
            Autologous CAR T Procedure (3 Weeks to 6+ Months)
          </h5>
          <img
            src={autologous}
            alt="Patient Identification - Attain manufacturing slot - Leukapheresis Scheduling - Leukapheresis - Manufacturing - Lymphodepletion - CAR T Therapy Administration"
            className="infographic__chart__type__img"
          />
          <div />
        </div>
      </div>

      <img
        src={infographicM}
        alt="Allogeneic Products (2 to 5 Days): Patient Identification - Lymphodepletion - AlloCAR T Product Administration, Autologous CAR T Procedure (3 Weeks to 6+ Months): Patient Identification - Attain manufacturing slot - Leukapheresis Scheduling - Leukapheresis - Manufacturing - Lymphodepletion - CAR T Therapy Administration"
        className="infographic__chart__img-mobile"
      />

      <img src={ellipse} alt="" className="infographic__ellipse infographic__ellipse--bottom" />
    </div>
  );
}

export default Infographic;
